import * as React from 'react';

import { Button, ButtonGroup } from '@shared/components/bootstrap';
import { UserRole } from '@shared/types/user_role';

import { Panel } from '@admin/components/helpers/panel';
import { ROLES } from '@admin/config/roles';
import { client } from '@admin/libraries/apollo';
import { useAdminDropOffAppointmentQuery } from '@admin/schema';

import { Thumbnails } from '../helpers/thumbnails';
import { Summary } from './manager/summary';
import { StorageArrangementManager } from './storage_arrangement_manager';

const ALLOWED_MANAGEMENT_ROLES = [
  UserRole.Admin,
  UserRole.SelfStorageAssociate,
  UserRole.Dispatcher,
  UserRole.Manager,
  UserRole.L2Agent,
];
const allowedToManage = ALLOWED_MANAGEMENT_ROLES.some((role) => ROLES.has(role));

export const DropOffManager: React.FC<{ orderID: string }> = ({ orderID }) => {
  const { data } = useAdminDropOffAppointmentQuery({
    client,
    variables: { orderID },
    fetchPolicy: 'network-only',
  });

  const dropOffAppointment = data?.dropOffAppointment;

  if (!dropOffAppointment) return null;

  return (
    <Panel>
      <Panel.Header>
        <Panel.Title>Drop Off Appointment</Panel.Title>
      </Panel.Header>
      <Panel.Body>
        <Summary appointment={dropOffAppointment} />
        <StorageArrangementManager appointment={dropOffAppointment} />
        {dropOffAppointment.files.length > 0 && (
          <>
            <p>
              <strong>Photos: </strong>
            </p>
            <Thumbnails condensed attachments={dropOffAppointment.files} />
          </>
        )}
      </Panel.Body>
      <Panel.Footer>
        {allowedToManage && (
          <div className="text-right">
            <ButtonGroup>
              <Button kind="danger" disabled>
                Cancel
              </Button>
              <Button kind="primary" disabled>
                Complete
              </Button>
            </ButtonGroup>
          </div>
        )}
      </Panel.Footer>
    </Panel>
  );
};
